'use client'

import { UserChatView } from '@/components/views/UserChatView'
import { useChatStore } from '@/store/useChatStore'
import { useEffect } from 'react'

export default function UserChatPage() {
  const createTempSession = useChatStore((state) => state.createTempSession)

  useEffect(() => {
    createTempSession()
  }, [createTempSession])

  return <UserChatView />
}
